<template>
  <div class="page landing">
    <section class="content">
      <div class="box">
        <div class="tips"></div>
        <div class="tips-text">【提示】</div>
        <p class="tips-exp">当前浏览器不支持身份识别</p>
        <div class="text">
          <img src="../landing/yzd/images/icon_05@2x.gif" alt="" class="text-img">
          关注天美贷公众号，直接提现
        </div>
        <div class="info">
          <div class="info-code">
            <img src="../landing/yzd/images/img_QR@2x.png" class="code-img">
            <p class="code-text">天美贷公众号</p>
          </div>
          <div class="info-ctrl">
            <div class="ctrl-info info-download" @click="handleDownload">
              <h5 class="info-h">点击下载二维码至相册</h5>
              <p class="info-p">微信扫一扫识别关注公众号</p>
            </div>
            <div class="ctrl-info info-copy" @click="copy">
              <h5 class="info-h">点击复制微信号   ct_tmd</h5>
              <p class="info-p">微信搜索关注公众号</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="btn-box tac">
      <nd-button class="btn-download" @click="downloadApp">下载天美贷APP立即提现</nd-button>
    </div>
    <nd-dialog
      v-model="visible"
      close-btn
    >
      <div class="dialog-content" slot="custom">
        <div class="title">下载链接</div>
        <div class="info">下载链接已复制到剪切板，请打开浏览器粘贴链接进行下载。</div>
        <div class="btn-group">
          <div class="btn copy" @click="hanldeCopy">复制链接</div>
        </div>
      </div>
    </nd-dialog>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
import { copyToClipbord, judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'

export default {
  data () {
    return {
      isIOS: judgeClientSystem() === 'IOS',
      visible: false
    }
  },
  created () {
    this.$bus.$emit('ready')
  },
  methods: {
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    },
    hanldeCopy () {
      // copyToClipbord('https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/apk/release/tmd_Offical_release.apk')
      // this.$message('已复制到剪贴板')
      this.copyUrlAndToast()
    },

    handleDownload () {
      console.log(this.getAndradoidUrl())
      this.downloadIamge(this.getAndradoidUrl(), 'qrcode')
    },
    handleOpenDialog () {
      this.$report({
        id: 50019,
        args: {
          target: 'YZD_RESULT'
        }
      })
      this.visible = true
    },

    async downloadIamge (imgsrc, name) {
      this.$report({
        id: 10299,
        args: {
          screen: 'page_landing_yzd_erro'
        }
      })
      if (hasNativeMethod('saveQRCode')) {
        const res = await jsBridge('saveQRCode', {
          url: imgsrc,
          name: name
        })
        if (res && res.code === 'OK') {
          this.saveSuccess()
        }
      } else if (this.isIOS) {
        this.$message('请长按左侧二维码保存')
      } else {
        let image = new Image()
        let self = this
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
          let a = document.createElement('a') // 生成一个a元素
          let event = new MouseEvent('click') // 创建一个单击事件
          a.download = name // 设置图片名称没有设置则为默认
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
          self.saveSuccess()
        }
        image.src = imgsrc
      }
    },

    saveSuccess () {
      this.$message('已保存至系统相册')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

  .dialog-content {
  background-color: #fff;
  width: 620px;
  border-radius: 30px;
  padding: 50px 40px 75px;
  .title{
    font-size: 38px;
    color: #333333;
    text-align: center;
    line-height: 72px;
    font-weight: bold;
  }
  .info{
    font-size: 28px;
    color: #666666;
    text-align: center;
    line-height: 45px;
    margin-top: 25px;
  }
  .btn-group{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 65px;
    .btn{
      width: 440px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      border: 2px solid #FF4633;
      border-radius: 40px;
      &.copy{
        color: #FF4633;
      }
      &.complete{
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        color: #ffffff;
      }
      & + .btn{
        margin-top: 20px;
      }
    }
  }
}
.landing{
  background: #F7F7F7;
  .btn-box {
    padding-top: 100px;
      .btn-download {
        margin:auto;
        animation: scaleBtn 1s infinite alternate;
      }
      @keyframes scaleBtn {
        to {
          transform: scale(1.1);
        }
      }
    }
  .content{
    background: url(../landing/yzd/images/img_bg.png) top center no-repeat;
    background-size: 100%;
    padding-top: 330px;
   
    .box{
      margin: 0 auto 0;
      width: 690px;
      height: 654px;
      background: #fff;
      padding: 34px 30px;
      border-radius: 20px;

      .tips {
        width:180px;
        height:180px;
        background: url(../landing/yzd/images/icon_gou.png) top center no-repeat;
        background-size: 180px 180px;
        margin: -90px auto 0;
      }
      .tips-text {
        font-size: 42px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF4633;
        text-align: center;
      }
      .tips-exp {
        font-size: 32px;
        text-align: center;
        padding-bottom: 60px;
      }
     
      .text{
        background: linear-gradient(180deg, #4F506E 0%, #3A3B53 100%);
        height: 94px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        color: #fff;
        font-weight: 500;
        border-radius: 8px;
        .text-img{
          width: 67px;
          height: 42px;
          margin-right: 10px;
        }
      }
      .info{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .info-code{
         background: #F7F7F7;
          border-radius: 8px;
          padding: 10px 10px 6px;
          .code-img{
            width: 140px;
            height: 140px;
          }
          .code-text{
            font-size: 20px;
            margin-top: 4px;
            color: #333333;
            text-align: center;
          }
        }
        .info-ctrl{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .ctrl-info{
           background: #F7F7F7;
            background-size: 30px;
            background-repeat: no-repeat;
            background-position: calc(100% - 20px) center;
            padding: 10px 30px;
            border-radius: 8px;
            width: 433px;
            .info-h{
              font-size: 26px;
              color: #333333;
              font-weight: 500;
            }
            .info-p{
              font-size: 20px;
              color: #9C9C9C;
            }
            &.info-download{
              background-image: url(../landing/yzd/images/icon_download@2x.png);
            }
            &.info-copy{
              background-image: url(../landing/yzd/images/icon_copy@2x.png);
            }
          }
        }
      }
    }
    .per-list{
      display: flex;
      justify-content: space-between;
      padding: 0 55px;
      margin-top: 90px;
      .item{
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-img{
          width: 90px;
          height: 90px;
        }
        .item-h{
          margin-top: 18px;
          color: #333333;
          font-size: 28px;
          font-weight: 500;
        }
        .item-p{
          font-size: 24px;
          color: #999999;
        }
      }
    }
  }
  .bottom{
    color: #D0BFB0;
    background-color: #FFFAF5;
    padding: 24px 50px 80px;
    margin-top: 50px;
    .bottom-p{
      font-size: 20px;
      line-height: 28px;
    }
    .bottom-h{
      font-size: 32px;
      margin-top: 25px;
      margin-bottom: 5px;
      line-height: 45px;
      background: url(../landing/yzd/images/icon_phone@2x.png) left center no-repeat;
      background-size: 32px;
      padding-left: 40px;
    }
    .bottom-btn{
      width: 520px;
      height: 94px;
      line-height: 94px;
      text-align: center;
      border-radius: 47px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      color: #fff;
      font-weight: 500;
      font-size: 36px;
      margin: 80px auto 0;
      animation: rotate 1s linear infinite;
    }
    @keyframes rotate {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(0.9);
      }
      100% {
        transform: scale(1);
      }
    }
  }
}
</style>